<template lang="pug">
  nuxt-child
</template>

<script>
export default {
  scrollToTop: true,
  meta: {
    logoText: 'brands'
  }
};
</script>
